module.exports = __webpack_public_path__ + "static/media/bulb.b029f5db.svg";